import PrimaryContent from './PrimaryContent.vue';
import TelemedicineContent from './TelemedicineContent.vue';
import IMIVVitaminTherapiesContent from './IMIVVitaminTherapiesContent.vue';
import PRPMicroneedlingFacialContent from './PRPMicroneedlingFacialContent.vue';
import HormoneReplacementContent from './HormoneReplacementContent.vue';
import EarLobeRepairContent from './EarLobeRepairContent.vue';
import WeightLossContent from './WeightLossContent.vue';
import FacialHarmonizationContent from './FacialHarmonizationContent.vue';

export const servicesContent = [
    { 
        id: 1, 
        labelPtBR: 'Cuidados Primários/Pediatria', 
        labelEn: 'Primary Care/Pediatric', 
        labelEs: 'Atención Primaria/Pediátrica',
        nameParams: 'primary-care', 
        component: PrimaryContent, 
        img: '1.jpg' 
    },
    { 
        id: 2, 
        labelPtBR: 'Telemedicina', 
        labelEn: 'Telemedicine', 
        labelEs: 'Telemedicina',
        nameParams: 'telemedicine', 
        component: TelemedicineContent, 
        img: '2.jpg' 
    },
    { 
        id: 3, 
        labelPtBR: 'IM / IV Terapias com Vitaminas ', 
        labelEn: 'IM/IV Vitamin Therapies', 
        labelEs: 'Terapias Vitamínicas IM/IV',
        nameParams: 'im-iv-vitamin-therapies', 
        component: IMIVVitaminTherapiesContent, 
        img: '3.jpg' 
    },
    { 
        id: 4, 
        labelPtBR: 'PRP / Microagulhamento / Facial', 
        labelEn: 'PRP / Microneedling/ Facial', 
        labelEs: 'PRP / Microneedling / Facial',
        nameParams: 'prp-microneedling-facial', 
        component: PRPMicroneedlingFacialContent, 
        img: '4.jpg' 
    },
    { 
        id: 5, 
        labelPtBR: 'Reposição Hormonal / Terapia Médica de Testosterona',
        labelEn: 'Hormone Replacement / Medical Testosterone Therapy',
        labelEs: 'Reemplazo Hormonal / Terapia Médica de Testosterona',
        nameParams: 'hormone-replacement-therapy', 
        component: HormoneReplacementContent, 
        img: '5.jpg' 
    },
    { 
        id: 6, 
        labelPtBR: 'Reparo do Lóbulo da Orelha / Remoção de Cisto', 
        labelEn: 'Ear Lobe Repair/ Cyst Removal', 
        labelEs: 'Reparación del Lóbulo de la Oreja / Extirpación de Quistes',
        nameParams: 'ear-lobe-repair-cyst-removal', 
        component: EarLobeRepairContent, 
        img: '6.jpg' 
    },
    {
        id: 7,
        labelPtBR: 'Perda de Peso / Redução de Gordura não Cirúrgica',
        labelEn: 'Weight Loss / Non-Surgical Fat Reduction',
        labelEs: 'Pérdida de Peso / Reducción de Grasa no Quirúrgica',
        nameParams: 'weight-loss-non-surgical-fat-reduction',
        routeTo: { name: 'WeightLoss' },
        component: WeightLossContent,
        img: '7.jpg'
    },
    { 
        id: 9, 
        labelPtBR: 'Harmonização Facial', 
        labelEn: 'Facial Harmonization', 
        labelEs: 'Armonización Facial',
        nameParams: 'facial-harmonization', 
        component: FacialHarmonizationContent, 
        img: '9.jpg' 
    }
]